import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { exportComponentAsJPEG } from 'react-component-export-image';
import { FaRegCircleXmark } from 'react-icons/fa6';
import formatDateYYYY from '~/services/formatDateYYYY';

import { Modal, ModalBody, ModalHeader } from 'reactstrap';

import { toast } from 'react-hot-toast';

import api from '~/services/api';
import { useAuth } from '~/context/AuthContext';
import { useTables } from '~/context/TablesContext';
import ImgToPrint from '~/components/ImgToPrint';
import { NewHeader } from '~/components/NewHeader';
import { DeliveryNavBar } from '~/components/DeliveryNavBar';
import { Button } from 'ui-kit-takeat';
import {
  CollapsableMenu,
  IconWarning,
  Button as UiButton,
  IconMenu,
  IconBookOpenFilled,
  IconBillFilled,
  IconPiggyBankFilled,
} from 'takeat-design-system-ui-kit';
import { useLocalStorage } from '~/hooks/useLocalStorage';
import { MENU_OBJECT } from '~/utils/menuItems';
import {
  Wrapper,
  Content,
  ContentOperation,
  Footer,
  SaveButton,
  FooterItem,
  PaymentAdvice,
  WarningArea,
} from './styles';

import { useChat } from '~/hooks/useChat';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const newOperationUrl = process.env.REACT_APP_NEW_OPERATION_URL;

const IframeComponent = ({useNewOperation}) => {
  const { user, token, signOut } = useAuth();
  const history = useHistory();
  const iframeRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const onEvent = (event) => {
      if (event.origin !== newOperationUrl) return;
      
      if (event.data.type === 'nav') {
        history.push(event.data.path);
      }

      if (event.data.type === 'info' && event.data.message === 'rendered') {
        iframeRef.current.contentWindow.postMessage(
          { type: 'login', user, token },
          newOperationUrl
        );
      }

      if(event.data.type === 'logout'){
        signOut()
      }
    };

    window.addEventListener('message', onEvent);
    return () => {
      window.removeEventListener('message', onEvent);
    };
  }, []);

  useEffect(() => {
    if (location.pathname !== '/operation') {
      iframeRef.current.contentWindow.postMessage(
        { type: 'left-operation' },
        newOperationUrl
      );
    }
  }, [location.pathname]);

  useEffect(() => {
    if(token === null){
       iframeRef.current.contentWindow.postMessage(
        { type: 'logout' },
        newOperationUrl
      );
    }
  }, [token])

  return (
    <iframe
      ref={iframeRef}
      src={newOperationUrl}
      width="100%"
      height="100%"
      style={{
        visibility: useNewOperation ? 'visible' : 'hidden',
        position: 'absolute',
        pointerEvents: useNewOperation ? 'auto' : 'none',
        zIndex: 999,
      }}
    />
  );
};

function AdminLayout({ children }) {
  const [isModalQrcodeOpened, setIsModalQrcodeOpened] = useState(false);
  const { tableMenu } = useTables();
  const [isSidebarOpen, setIsSidebarOpen] = useLocalStorage(
    'isSidebarOpen',
    false
  );

  useChat();

  const {
    user,
    websocketManager,
    updateUser,
    setData,
    expiresAtCertificateType,
    setExpiresAtCertificateType,
    signOut,
    handleOpenAsaas,
    hasOverdueUrl,
  } = useAuth();

  const imgRef = useRef(null);

  const toggleModalQrcode = () => {
    setIsModalQrcodeOpened(!isModalQrcodeOpened);
  };

  const page = window.location.pathname;

  const useNewOperation = user?.use_new_operation && page === '/operation';

  const firstPath = page.split('/')[1];
  const secondPath = page.split('/')[2];
  const history = useHistory();

  useEffect(() => {
    if (websocketManager) {
      websocketManager.addMessageCallback(4, (data) => {
        if (data.type === 'enable-menu') {
          const { value } = data;

          updateUser({
            enable_menu: value === 'true',
          });
        }
      });
    }
  }, [websocketManager, updateUser]);

  const [pendingPaymentNotificationOpen, setPendingPaymentNotificationOpen] =
    useState(false);

  const handleNotifyPayment = async () => {
    try {
      const response = await api.put('/restaurants/notify-payment');
      console.log('response ', response.data);
    } catch (err) {
      console.log(err);
      toast.error('Erro ao notificar pagamento');
    }
  };

  const updateDataWithNotifyPayment = async () => {
    try {
      const response = await api.put('/restaurants/notify-payment');
      console.log('response ', response.data);
      setData((state) => {
        return {
          ...state,
          user: {
            ...state.user,
            temporary_active: response.data.temporary_active,
            suspension_alert: response.data.suspension_alert,
            is_active: response.data.is_active,
          },
        };
      });
    } catch (err) {
      console.log(err);
      toast.error('Erro ao notificar pagamento');
    }
  };

  const openNotifyPaymentModal = () => {
    setPendingPaymentNotificationOpen(true);
    if (!user?.temporary_active) {
      handleNotifyPayment();
    }
  };

  const hideSideBar = [
    '/operation',
    '/operation/',
    '/balcony',
    '/balcony/',
    '/balance',
    '/balance/',
    '/kds-password/',
    '/kds-password',
    '/drive-thru',
    '/drive-thru/',
    '/kitchen',
    '/kitchen/',
  ];

  const hideFooter = [
    '/balance',
    '/balance/',
    '/kds-password/',
    '/kds-password',
    ...(useNewOperation && ['/operation', '/operation/'] || []),
  ];

  function getWarningText(item) {
    if (item === 2) {
      return 'Seu certificado vence amanhã. Evite problemas com a emissão de notas e solicite a sua contabilidade um novo certificado A1 em formato .pfx e acione nosso suporte.';
    }
    if (item === 7) {
      return 'Seu certificado vence em 7 dias. Entre em contato com sua contabilidade para renovar o certificado A1 em formato .pfx e assim que estiver pronto, acione o nosso time do suporte para atualizarmos em seu sistema.';
    }
    if (item === 30) {
      return 'Seu certificado vence em 30 dias.';
    }

    return false;
  }

  function getWarningColor(item) {
    if (item === 2) {
      return '#C8131B';
    }
    if (item === 7) {
      return '#FFB32F';
    }
    if (item === 30) {
      return '#01AFFF';
    }

    return '#333';
  }

  if (!user) {
    return children;
  }

  return hideSideBar.includes(page) ? (
    <>
      <IframeComponent useNewOperation={useNewOperation} />
      {/* <WaiterPos key={page}/> */}
      <Modal
        isOpen={pendingPaymentNotificationOpen}
        toggle={() => setPendingPaymentNotificationOpen(false)}
        onClosed={() => {
          if (!user.temporary_active) {
            updateDataWithNotifyPayment();
          }
          setPendingPaymentNotificationOpen(false);
        }}
        size="md"
      >
        <ModalBody
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 24,
            padding: 16,
          }}
        >
          {user.temporary_active ? (
            <>
              <p
                style={{
                  color: '#4D4D4C',
                  textAlign: 'center',
                  fontFamily: 'Poppins',
                  fontSize: 18,
                  fontStyle: 'normal',
                  fontWeight: 700,
                  lineHeight: 'normal',
                  alignSelf: 'flex-start',
                }}
              >
                Você já informou ter realizado o pagamento
              </p>
              <p
                style={{
                  color: '#4D4D4C',
                  textAlign: 'justify',
                  fontFamily: 'Poppins',
                  fontSize: 16,
                  fontStyle: 'normal',
                  fontWeight: 500,
                  lineHeight: 'normal',
                  marginBottom: 0,
                  alignSelf: 'flex-start',
                }}
              >
                Assim que o pagamento for confirmado, sua conta será
                desbloqueada automaticamente. A equipe de suporte não é mais
                responsável pelo desbloqueio do seu sistema
              </p>
              <p
                style={{
                  color: '#4D4D4C',
                  textAlign: 'justify',
                  fontFamily: 'Poppins',
                  fontSize: 16,
                  fontStyle: 'normal',
                  fontWeight: 500,
                  lineHeight: 'normal',
                  marginBottom: 0,
                  alignSelf: 'flex-start',
                }}
              >
                Esse processo pode levar até 3 dias úteis.
              </p>
            </>
          ) : (
            <>
              <p
                style={{
                  color: '#4D4D4C',
                  textAlign: 'center',
                  fontFamily: 'Poppins',
                  fontSize: 18,
                  fontStyle: 'normal',
                  fontWeight: 700,
                  lineHeight: 'normal',
                  alignSelf: 'flex-start',
                }}
              >
                Sistema liberado!
              </p>
              <p
                style={{
                  color: '#4D4D4C',
                  textAlign: 'justify',
                  fontFamily: 'Poppins',
                  fontSize: 16,
                  fontStyle: 'normal',
                  fontWeight: 500,
                  lineHeight: 'normal',
                  marginBottom: 0,
                  alignSelf: 'flex-start',
                }}
              >
                Seu acesso foi temporariamente liberado enquanto verificamos o
                pagamento. Se não for identificado dentro de 3 dias úteis, o
                sistema automaticamente bloqueará sua conta novamente.
              </p>
            </>
          )}
          <Button
            type="button"
            buttonColor="#2EC9B7"
            title="Confirmar"
            onClick={() => {
              if (!user.temporary_active) {
                updateDataWithNotifyPayment();
              }
              setPendingPaymentNotificationOpen(false);
            }}
          />
        </ModalBody>
      </Modal>
      {user.suspension_alert && user.is_active && (
        <PaymentAdvice>
          <FaRegCircleXmark size={32} color="#FF2C3A" />
          {user.suspension_date ? (
            <p>
              Sua conta será bloqueada no dia{' '}
              <b>{formatDateYYYY(new Date(user.suspension_date))}</b> Renove seu
              pagamento e evite o bloqueio do sistema.
            </p>
          ) : (
            <p>
              Sua conta está prestes a ser suspensa. Renove seu pagamento e
              evite o bloqueio do sistema
            </p>
          )}
          <Button
            type="button"
            title="Abrir faturas"
            textStyle={{ fontWeight: 700, whiteSpace: 'nowrap', fontSize: 14 }}
            onClick={handleOpenAsaas}
          />
        </PaymentAdvice>
      )}
      {!user.is_active && hasOverdueUrl && (
        <PaymentAdvice style={{ backgroundColor: '#F7C3CA' }}>
          <FaRegCircleXmark size={32} color="#FF2C3A" />
          <p>
            Conta <b>bloqueada</b> por falta de pagamento.
          </p>
          <Button
            type="button"
            title="Abrir faturas"
            textStyle={{ fontWeight: 700, whiteSpace: 'nowrap', fontSize: 14 }}
            onClick={handleOpenAsaas}
          />
          <Button
            type="button"
            title="Já efetuei o pagamento"
            inverted
            textStyle={{ fontWeight: 700, whiteSpace: 'nowrap', fontSize: 14 }}
            onClick={openNotifyPaymentModal}
          />
        </PaymentAdvice>
      )}
      {expiresAtCertificateType && (
        <WarningArea expiresAtCertificateType={expiresAtCertificateType}>
          <span
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              justifyContent: 'flex-start',
            }}
          >
            <IconWarning
              style={{
                fontSize: 24,
                fill: getWarningColor(expiresAtCertificateType),
              }}
            />
            <span>{getWarningText(expiresAtCertificateType)}</span>
          </span>

          {expiresAtCertificateType <= 2 && (
            <UiButton onClick={() => setExpiresAtCertificateType(null)}>
              Ciente
            </UiButton>
          )}
        </WarningArea>
      )}
      <ContentOperation>{children}</ContentOperation>
      <Modal isOpen={isModalQrcodeOpened} toggle={toggleModalQrcode}>
        <ModalHeader>Cardápio Digital</ModalHeader>
        <ModalBody>
          <p>
            Agora você pode compartilhar seu cardápio em suas redes sociais!
            Basta salvar o QrCode ou copiar o link e compartilhar à vontade.
            Aproveite!
          </p>

          <p>Link: {tableMenu && tableMenu?.table_code?.restaurant_url}</p>
          {tableMenu && (
            <>
              <ImgToPrint ref={imgRef} imgSrc={tableMenu?.table_code?.url} />

              <SaveButton
                type="button"
                onClick={() => exportComponentAsJPEG(imgRef)}
              >
                Baixar Imagem
              </SaveButton>
            </>
          )}
        </ModalBody>
      </Modal>
      {!user.is_pdv && !hideFooter.includes(page) && (
        <Footer>
          <FooterItem
            className="botao-menu"
            onClick={() => history.push('/search')}
          >
            <IconMenu />
            <span>Menu</span>
          </FooterItem>

          <FooterItem onClick={() => history.push('/register/menu')}>
            <IconBookOpenFilled />
            <span>Cardápio</span>
          </FooterItem>

          <FooterItem onClick={() => history.push('/operation/bills')}>
            <IconBillFilled />
            <span>Comandas</span>
          </FooterItem>

          {user.has_nfce && (
            <FooterItem onClick={() => history.push('/fiscal/issued')}>
              <IconPiggyBankFilled />
              <span>Notas Emitidas</span>
            </FooterItem>
          )}
        </Footer>
      )}
    </>
  ) : (
    <>
      <IframeComponent useNewOperation={useNewOperation} />
      <Modal
        isOpen={pendingPaymentNotificationOpen}
        toggle={() => setPendingPaymentNotificationOpen(false)}
        onClosed={() => {
          if (!user.temporary_active) {
            updateDataWithNotifyPayment();
          }
          setPendingPaymentNotificationOpen(false);
        }}
        size="md"
      >
        <ModalBody
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 24,
            padding: 16,
          }}
        >
          {user.temporary_active ? (
            <>
              <p
                style={{
                  color: '#4D4D4C',
                  textAlign: 'center',
                  fontFamily: 'Poppins',
                  fontSize: 18,
                  fontStyle: 'normal',
                  fontWeight: 700,
                  lineHeight: 'normal',
                  alignSelf: 'flex-start',
                }}
              >
                Você já informou ter realizado o pagamento
              </p>
              <p
                style={{
                  color: '#4D4D4C',
                  textAlign: 'justify',
                  fontFamily: 'Poppins',
                  fontSize: 16,
                  fontStyle: 'normal',
                  fontWeight: 500,
                  lineHeight: 'normal',
                  marginBottom: 0,
                  alignSelf: 'flex-start',
                }}
              >
                Assim que o pagamento for confirmado, sua conta será
                desbloqueada automaticamente. A equipe de suporte não é mais
                responsável pelo desbloqueio do seu sistema
              </p>
              <p
                style={{
                  color: '#4D4D4C',
                  textAlign: 'justify',
                  fontFamily: 'Poppins',
                  fontSize: 16,
                  fontStyle: 'normal',
                  fontWeight: 500,
                  lineHeight: 'normal',
                  marginBottom: 0,
                  alignSelf: 'flex-start',
                }}
              >
                Esse processo pode levar até 3 dias úteis.
              </p>
            </>
          ) : (
            <>
              <p
                style={{
                  color: '#4D4D4C',
                  textAlign: 'center',
                  fontFamily: 'Poppins',
                  fontSize: 18,
                  fontStyle: 'normal',
                  fontWeight: 700,
                  lineHeight: 'normal',
                  alignSelf: 'flex-start',
                }}
              >
                Sistema liberado!
              </p>
              <p
                style={{
                  color: '#4D4D4C',
                  textAlign: 'justify',
                  fontFamily: 'Poppins',
                  fontSize: 16,
                  fontStyle: 'normal',
                  fontWeight: 500,
                  lineHeight: 'normal',
                  marginBottom: 0,
                  alignSelf: 'flex-start',
                }}
              >
                Seu acesso foi temporariamente liberado enquanto verificamos o
                pagamento. Se não for identificado dentro de 3 dias úteis, o
                sistema automaticamente bloqueará sua conta novamente.
              </p>
            </>
          )}
          <Button
            type="button"
            buttonColor="#2EC9B7"
            title="Confirmar"
            onClick={() => {
              if (!user.temporary_active) {
                updateDataWithNotifyPayment();
              }
              setPendingPaymentNotificationOpen(false);
            }}
          />
        </ModalBody>
      </Modal>

      {/* <ModalCoverDelivery isSidebarOpen={isSidebarOpen} /> */}
      {expiresAtCertificateType && (
        <WarningArea expiresAtCertificateType={expiresAtCertificateType}>
          <span
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              justifyContent: 'flex-start',
            }}
          >
            <IconWarning
              style={{
                fontSize: 24,
                fill: getWarningColor(expiresAtCertificateType),
              }}
            />
            <span>{getWarningText(expiresAtCertificateType)}</span>
          </span>

          {expiresAtCertificateType <= 2 && (
            <UiButton onClick={() => setExpiresAtCertificateType(null)}>
              Ciente
            </UiButton>
          )}
        </WarningArea>
      )}

      {user.suspension_alert && user.is_active && (
        <PaymentAdvice>
          <FaRegCircleXmark size={32} color="#FF2C3A" />
          {user.suspension_date ? (
            <p>
              Sua conta será bloqueada no dia{' '}
              <b>{formatDateYYYY(new Date(user.suspension_date))}</b> Renove seu
              pagamento e evite o bloqueio do sistema.
            </p>
          ) : (
            <p>
              Sua conta está prestes a ser suspensa. Renove seu pagamento e
              evite o bloqueio do sistema
            </p>
          )}
          <Button
            type="button"
            title="Abrir faturas"
            textStyle={{ fontWeight: 700, whiteSpace: 'nowrap', fontSize: 14 }}
            onClick={handleOpenAsaas}
          />
        </PaymentAdvice>
      )}

      {!user.is_active && hasOverdueUrl && (
        <PaymentAdvice style={{ backgroundColor: '#F7C3CA' }}>
          <FaRegCircleXmark size={32} color="#FF2C3A" />
          <p>
            Conta <b>bloqueada</b> por falta de pagamento.
          </p>
          <Button
            type="button"
            title="Abrir faturas"
            textStyle={{ fontWeight: 700, whiteSpace: 'nowrap', fontSize: 14 }}
            onClick={handleOpenAsaas}
          />
          <Button
            type="button"
            title="Liberar por mais 3 dias"
            inverted
            textStyle={{ fontWeight: 700, whiteSpace: 'nowrap', fontSize: 14 }}
            onClick={openNotifyPaymentModal}
          />
        </PaymentAdvice>
      )}

      <Wrapper>
        {!user.is_pdv &&
          user.enable_menu &&
          page !== '/kds' &&
          page !== '/kitchen' && (
            <>
              <CollapsableMenu
                style={{ zIndex: 999 }}
                defaultSideBarOpen={isSidebarOpen}
                onSideBarToggle={(e) => setIsSidebarOpen(e)}
                menuObject={MENU_OBJECT(user, signOut)}
              />
            </>
          )}

        <Content>
          <NewHeader isSidebarOpen={isSidebarOpen} />
          {firstPath === 'delivery' && secondPath !== 'orders' && secondPath !== 'scheduled-calendar' && (
            <div style={{ padding: '20px' }}>
              <DeliveryNavBar />
            </div>
          )}
          {children}
        </Content>
      </Wrapper>
    </>
  );
}

export default AdminLayout;

AdminLayout.propTypes = {
  children: PropTypes.element.isRequired,
};
